import { CreditsIcon } from "@/components/Icons/CreditsIcon";
import { USDIcon } from "@/components/Icons/USDIcon";
// import env from "@/env";
import { executeAPIRequest } from "./api";

let isCreditsEnabled = true;

export const setIsCreditsEnabled = (enabled: boolean) => {
  isCreditsEnabled = enabled;
};

export const getIsCreditsEnabled = () => {
  return isCreditsEnabled;
};

export const getCreditsPaymentOption = () => {
  if (isCreditsEnabled) {
    return {
      label: <CreditsIcon className="h-[12px]" />,
      value: "credits",
      disabled: false,
      customRadio: null
    };
  }

  return {
    label: <USDIcon className="h-[22px]" />,
    value: "usd",
    customRadio: (
      <p className="subtext-x-small rounded-xs bg-gray-dark-900 px-1 py-1 text-gray-dark-1000">
        Coming Soon
      </p>
    ),
    disabled: true
  };
};

export const requestCredits = async (data: { name: string; reason: string; amount: number }) => {
  await executeAPIRequest<{
    status: string;
  }>({
    method: "post",
    url: `/io-user/io-credits/request`,
    options: {
      data
    }
  });
};

export const withdrawCredits = async (data: { amount: number; walletAddress: string }) => {
  await executeAPIRequest<{
    status: string;
  }>({
    method: "post",
    url: `/io-user/io-credits/request-withdraw`,
    options: {
      data: {
        amount: data.amount,
        user_wallet_address: data.walletAddress
      }
    }
  });
};

export const getCurrencyParam = (currency: string | undefined) => {
  return currency === "credits" || currency === "stripe" ? "usdc" : currency;
};
